module.exports = __webpack_public_path__ + "6e9ef1cbbdcf86a551ded783775427d4.png";